/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: liguokang
 * @LastEditTime: 2021-06-03 19:43:42
 * @Description:
 */
import store from './index';

/**
 * 弹出确认框
 */
window.showConfirm = function(title, message, okText, cancleText, showCancle) {
  return store.dispatch('showConfirm', {
    title: title,
    message: message,
    okText: okText,
    cancleText: cancleText,
    showCancle: showCancle,
  });
};

window.showUnderEnter = function(title, okText, cancleText, onOk, onCancle) {
  return store.dispatch('showUnderEnter', {
    title,
    okText,
    cancleText,
    onOk,
    onCancle,
  });
};

window.hideUnderEnter = function() {
  store.dispatch('hideUnderEnter', {});
};

window.showLoading = function() {
  store.dispatch('showLoading', {});
};

window.hideLoading = function() {
  store.dispatch('hideLoading', {});
};

window.saveUserInsts = function(insts) {
  store.dispatch('saveUserInsts', {
    insts: insts,
  });
};

window.changeCurrentInst = function(instId) {
  store.dispatch('changeCurrentInst', {
    instId: instId,
  });
};



// WEBPACK FOOTER //
// ./src/store/dispatch.js